import { toast } from '@huspy/forge/shared';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useShallowEffect } from '@mantine/hooks';
import { coreApi } from '@modules/core/api';
import { CreditsRouteSearchQuery } from '@modules/core/presentation/v2/routes';

const useGetCreditsTransactions = (q: CreditsRouteSearchQuery, brokerageExternalId?: string) => {
  const [query, setQuery] = useState<CreditsRouteSearchQuery>(q);
  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['creditsTransactionsList', query],
    queryFn: () => coreApi.getCreditsTransactions(query, brokerageExternalId),
    staleTime: 1_200_000,
    enabled: !!brokerageExternalId,
  });

  // https://mantine.dev/hooks/use-shallow-effect/
  useShallowEffect(() => {
    setQuery(q);
  }, [q]);

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};

export default useGetCreditsTransactions;
